export const environment = {
  production: true,
  idam_client_id: 'TPmOI4f0eDrYqzRu2a4BXNhe4vHJt4jY',
  uri: {
    api: {
      isApiGateWayEnabled: true,
      //security: 'https://uat-api-security.london.cloudapps.digital',
      security: 'https://uat.api.gca.gov.uk',
      //postgres: 'https://uat-api-core.london.cloudapps.digital',
      postgres: 'https://uat.api.gca.gov.uk/dashboard-wrapper',
      //cii: 'https://conclave-cii-integration-brash-shark-mk.london.cloudapps.digital',
      wrapper: {
        apiGatewayEnabled: {
          user: 'https://uat.api.gca.gov.uk/user-profile',
          organisation: 'https://uat.api.gca.gov.uk/organisation-profile',
          contact: 'https://uat.api.gca.gov.uk/contact-service',
          configuration: 'https://uat.api.gca.gov.uk/configuration-service',
          dataMigration: 'https://uat.api.gca.gov.uk/organisation-profile/datamigration',
        },
        apiGatewayDisabled: {
          user: 'https://uat.ppg-sso-service.gca.gov.uk/user-profile',
          organisation: 'https://uat.ppg-sso-service.gca.gov.uk/organisation-profile',
          contact: 'https://uat.ppg-sso-service.gca.gov.uk/contact-service',
          configuration: 'https://uat.ppg-sso-service.gca.gov.uk/configuration-service',
          dataMigration: 'https://uat.ppg-sso-service.gca.gov.uk/organisation-profile/datamigration',
        }
      }
    },
    web: {
      //dashboard: 'https://uat-ccs-sso.london.cloudapps.digital'
      dashboard: 'https://uat.identify.gca.gov.uk',
      name: "UAT"
    },
    ccsContactUrl: "https://webuat.gca.gov.uk/contact",
    ccsDashboardUrl: "https://webuat.gca.gov.uk"
  },

  googleTagMangerId: 'GTM-TZCX5VP',
  cookieExpirationTimeInMinutes: 525600,
  bulkUploadPollingFrequencyInSeconds: 5,
  bulkUploadMaxFileSizeInBytes:1048576,
  bulkUploadTemplateFileUrl: 'https://uat.api.gca.gov.uk/templates/DataMigrationTemplate.csv',
  usedPasswordThreshold: 5, //This value should be changed when Auth0 password history policy changed,
  listPageSize: 10,
  mailDecryptKey:'conclavesimpleemailencrypt',
  rollbar: {
    key: '3928c5854c7e4df9afb0582396a7cae3',
    enable: false,
    security_log:false,
    environment: 'uat-ccs-sso'
  },
  cookies_policy: {
    essentialcookies: {
        notify_admin_session: 20,
        cookie_policy: 1,
        ccs_sso_visitedsites: 60,
        opbs: 60,
        ccs_sso: 60,
        conclave: 60,
        XSRF_TOKEN: 30,
        XSRF_TOKEN_SVR: 30,
        AspNetCore_Antiforgery_GWNWkbbyKbw: 30
    },
    Auth0cookies: {
        auth0_compat: 3,
        did_compat: 6,
        did: 6,
        auth0: 3,
        __cf_bm: 30
    },
  },
  appSetting: {
   hideIDP:true,
   hideDelegation:false,
   hideBulkupload:false,
   hideAutoValidation:false,
   hideSimplifyRole: false,
   blockedScheme: ["GB-PPG"],
   customMfaEnabled: true,
   isMaintenance: false,
   excludedForDelegation: ['ORG_ADMINISTRATOR', 'ORG_DEFAULT_USER', 'ORG_USER_SUPPORT', 'MANAGE_SUBSCRIPTIONS', 'DATA_MIGRATION', 'CAT_ADMIN'],
  },
};
